module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columnsCorrespondence,
      "rows": _vm.rowsCorrespondence,
      "globalSearch": false,
      "paginate": false
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.row.type !== 'messages' || _vm.user.twilioStatus) ? _c('div', [(props.column.field === 'action') ? _c('div', [_c('actions-menu', [_c('actions-menu-item', {
          attrs: {
            "title": "Export PDF",
            "icon": "fa-file-pdf-o",
            "href": _vm.getDownloadUrl(props.row.type, 'pdf')
          }
        }), _vm._v(" "), _c('actions-menu-item', {
          attrs: {
            "title": "Export XLS",
            "icon": "fa-file-excel-o",
            "href": _vm.getDownloadUrl(props.row.type, 'xls')
          }
        }), _vm._v(" "), _c('actions-menu-item', {
          attrs: {
            "title": "Export CSV",
            "href": _vm.getDownloadUrl(props.row.type, 'csv'),
            "icon-src": "/static/global/img/csv-ico.svg"
          }
        })], 1)], 1) : _c('span', [_vm._v(_vm._s(props.formattedRow[props.column.field]))])]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('br'), _vm._v("`\n  "), (_vm.$route.params.id != null) ? _c('router-link', {
    staticClass: "btn green",
    attrs: {
      "to": {
        name: 'Dashboard Participant',
        params: {
          id: _vm.$route.params.id
        }
      },
      "tag": "button",
      "type": "button"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.participantSingularName) + " Dashboard\n  ")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8742128a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Participant/Correspondence.vue
// module id = 1718
// module chunks = 1